import { SentryLogs } from '@services/SentryLogs';

const DNS = 'https://150f3d7128254e3e9fef7b75b756f397@sentry.io/1550913';
const ENVIRONMENT = process.env.NODE_ENV === 'production' ? 'production' : 'development';
const APP_VERSION = 'kss@' + process.env.APP_VERSION;

export const kssSentryLogs = new SentryLogs(DNS, ENVIRONMENT, APP_VERSION);
